export enum ReturnPurposeEnum {
    NEW = 'NEW',
    BROKEN = 'BROKEN',
}


export enum ShiftEnum {

    GENERAL = 'General',
    SHIFT_A = 'Shift A',
    SHIFT_B = 'Shift B',
    SHIFT_C = 'Shift C',
    }

    export enum ReturnStatusEnum {
        PartiallyReceived = 'Partially Received ',
        Received = 'Received',
        Open = 'Open',
    }